import { useCallback, useEffect, useState } from "react";
import { LuXCircle } from "react-icons/lu";
import PageIntro from "src/components/PageIntro/PageIntro";
import { Button } from "src/components/ui/button";
import UploadContractModal from "./UploadContractModal";
import { SelectedContract } from "../types/SelectedContract";
import { OfferForm } from "src/pages/ProjectSetup/types/OfferObject";
import { augmentContractPdf } from "./augmentContractPdf";
import { generateDroomworkContract } from "./generateDroomworkContract";


const droomworkAgreement = process.env.REACT_APP_DROOMWORK_CONTRACT_URL;


const contractOptions = [
  {
    value: "droomwork",
    label: "Standard Droomwork Agreement",
  },
  {
    value: "custom",
    label: "Custom Contract",
  },
];

export default function ProjectContractSetup({
  offer,
  onBack,
  onNext,
  clientName = "",
  contractorName = "",
}: {
  offer?: OfferForm;
  onBack: () => void;
  onNext: (contract: SelectedContract[]) => void;
  clientName?: string;
  contractorName?: string;
}) {
  const [error, setError] = useState<string>();
  const [selectedContractOption, setContractOption] = useState<string>();
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [customContractData, setCustomContractData] = useState<
    {
      type: string;
      pdf: File;
    }[]
  >([]);

  // const droomwork = ''

  // const handleSelectContract = (value: string) => {
  //   setError(undefined);
  //   if (value == "custom") {
  //     openContractUploadModal();
  //   }
  //   setContractOption(value);
  // };

  // console.log('Droomwork Contact url:', droomworkAgreement
    
  //)


  const handleSelectContract = (value: string) => {
  setError(undefined);
  

  if (value == "custom") {
    openContractUploadModal();
  }
  
  if (value == "droomwork") {
    setCustomContractData([]); 
  }
  
  setContractOption(value);
};


  
  const openContractUploadModal = useCallback(() => {
    setOpenUploadModal(true);
  }, [openUploadModal]);

  const closeContractUploadModal = useCallback(() => {
    setOpenUploadModal(false);
  }, [openUploadModal]);

  // const handleNext = async () => {
  //   if (!offer) return;
  //   if (!selectedContractOption) return setError("Choose contract option.");
  //   if (selectedContractOption == "droomwork") return onNext([]);

  //     if (selectedContractOption == "droomwork") {
  //   const contractUrl = process.env.REACT_APP_DROOMWORK_CONTRACT_URL;
  //   if (!contractUrl) return setError("Contract not available.");

  //   const res = await fetch(contractUrl);
  //   const blob = await res.blob();
  //   const file = new File([blob], "droomwork-agreement.pdf", { type: "application/pdf" });

  //   return onNext([
  //     {
  //       provider: "droomwork",
  //       type: "droomwork_agreement",
  //       file,
  //     }
  //   ]);
  // }


  const handleNext = async () => {
  if (!offer) return;
  if (!selectedContractOption) return setError("Choose contract option.");

  if (selectedContractOption == "droomwork") {
    if (!offer) return setError("Offer details not found.");
    // Generate the full droomwork agreement PDF from scratch with dynamic values
    const file = await generateDroomworkContract({ offer, clientName, contractorName });
    return onNext([{ provider: "droomwork", type: "droomwork_agreement", file }]);
  }

  if (customContractData.length == 0)
    return setError("You have to upload custom contracts to continue.");

  const data = await Promise.all(
    customContractData.map(async ({ type, pdf }) => {
      const processedPDF = type == "SLA" ? await augmentContractPdf({ pdf, offer }) : pdf;
      return { provider: selectedContractOption as "droomwork" | "custom", type, file: processedPDF };
    })
  );

  onNext(data);
};


  //   if (customContractData.length == 0)
  //     return setError("You have to upload custom contracts to continue.");

  //   const data = await Promise.all(
  //     customContractData.map(async ({ type, pdf }) => {
  //       const processedPDF =
  //         type == "SLA" ? await augmentContractPdf({ pdf, offer }) : pdf;

  //       return {
  //         provider: selectedContractOption as "droomwork" | "custom",
  //         type,
  //         file: processedPDF,
  //       };
  //     })
  //   );


  //   onNext(data);
  // };

      // console.log("Data in contract: ", data);
  // console.log('Contract details:', offer)
  // console.log('CustomContractData:', customContractData)

  useEffect(() => {
    if (!offer) onBack();
  }, [offer]);

  return (
    <>
      <div>
        <PageIntro
          title="Select Contract"
          description="Use droomwork's contract templates or upload your own contrct.  For custom uploaded contracts, project  deails will be added to the pdf  document."
        />

        <div
          role="listbox"
          aria-orientation="vertical"
          className="flex gap-4 flex-col mt-5"
        >
          {contractOptions.map(({ value, label }, index) => {
            const selected = selectedContractOption == value;
            return (
              <div
                key={value}
                tabIndex={0}
                role="option"
                aria-selected={true}
                className="p-4 rounded-md border-2 cursor-pointer focus:ring-2 ring-slate-200 ring-offset-2 hover:bg-surface/60"
                onClick={() => handleSelectContract(value)}
              >
                <div className="flex items-center gap-4 ">
                  <div
                    aria-checked={selected}
                    className={`${
                      !selected ? "rounded-md" : "rounded-full bg-primary"
                    } w-5 h-5 p-0.5 border-2 transition-all duration-100 checked:bg-red `}
                  />
                  <p>{label}</p>
                </div>
                {selectedContractOption == "custom" && selected && (
                  <Button
                    type="button"
                    onClick={openContractUploadModal}
                    variant={"link"}
                    size={"sm"}
                    className="mt-3"
                  >
                    Upload {customContractData.length == 0 ? "" : "more"} pdf
                  </Button>
                )}

                {selectedContractOption == "droomwork" && selected && (
                  <a
                    href={droomworkAgreement}
                    target="_blank"
                    rel="noreferrer"
                    className="mt-3 block text-sm text-blue-600 hover:underline"
                    onClick={(e) => e.stopPropagation()}
                  >
                    View Agreement
                  </a>
                )}
                
                
              </div>
            );
          })}

          {/* Add droomwork PDF also when slected */}

              {/* <div className="flex gap-4 items-center flex-1">
                      <img
                        className="w-10 h-10 bg-surface rounded-md"
                        src={"/images/icons/pdf-file.svg"}
                      />
                      <div>
                        <p className="leading-snug text-semibold">{type}</p>
                      </div>
                    </div> */}

          {customContractData.length != 0 && (
            <div className="space-y-1">
              {customContractData.map(({ type }, index) => {
                return (
                  <div
                    key={index}
                    className="flex gap-4 items-center border-2 p-2 rounded"
                  >
                    <div className="flex gap-4 items-center flex-1">
                      <img
                        className="w-10 h-10 bg-surface rounded-md"
                        src={"/images/icons/pdf-file.svg"}
                      />
                      <div>
                        <p className="leading-snug text-semibold">{type}</p>
                      </div>
                    </div>
                    <Button
                      onClick={() => {
                        setCustomContractData((prev) =>
                          prev.filter((pred) => pred.type != type)
                        );
                      }}
                      variant={"ghost"}
                      size="sm"
                      className="rounded-full text-xl hover:bg-surface"
                    >
                      <LuXCircle />
                    </Button>
                  </div>
                );
              })}

              <p className="mt-4 text-sm">Previewable during signing... </p>
            </div>
          )}

          {error && <p className="text-red-600">{error}</p>}

          <div className="flex justify-between mt-10 ">
            <Button
              onClick={onBack}
              variant={"ghost"}
              size="sm"
              className=" hover:bg-surface"
            >
              Back
            </Button>
            <Button onClick={handleNext} size="sm" className="text-white px-5">
              Next
            </Button>
          </div>
        </div>

      </div>

      {openUploadModal && (
        <UploadContractModal
          availableTypes={customContractData.map((item) => item.type)}
          open={openUploadModal}
          onSuccess={({ type, file }) => {
            setCustomContractData((prev) => [...prev, { type, pdf: file }]);
          }}
          closeModal={closeContractUploadModal}
        />
      )}
    </>
  );
}
